export { v1IntegrationsAdapter as dataAdapter } from 'modules/Integrations/communication/external/v1/adapters/integrations.adapters'
